import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable()
export class SubjectcommonService {
  myMessage = new Subject<string>();
  SwmMyMessage = new Subject<boolean>();
  UlbMyMessage = new Subject<boolean>();
  constructor() { }
  getMessage(): Observable<string> {
    return this.myMessage.asObservable();
  }
  updateMessage(message: string) {
    this.myMessage.next(message);
  }

  SwmGetMessage(): Observable<boolean> {
    return this.SwmMyMessage.asObservable();
  }
  SwmUpdateMessage(message: boolean) {
    this.SwmMyMessage.next(message);
  }

  UlbGetMessage(): Observable<boolean> {
    return this.UlbMyMessage.asObservable();
  }
  UlbUpdateMessage(message: boolean) {
    this.UlbMyMessage.next(message);
  }
}
